import React, { useState, useEffect } from "react";
import { Text } from "../languages/Language";

const LoadingOverlay = () => {
  const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    backdropFilter: "blur(0.5px)",
    display: "flex",
    flexDirection: "column", // ALT ALTA DİZİM
    alignItems: "center",
    justifyContent: "center",
    zIndex: 999999,
    fontFamily: "Arial, sans-serif",
  };

  const spinnerStyle = {
    width: "50px",
    height: "50px",
    border: "5px solid #ccc",
    borderTop: "5px solid #000",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  };

  const textStyle = {
    marginTop: "16px",
    fontSize: "18px",
    color: "#333",
    fontWeight: "500",
  };

  return (
    <div style={overlayStyle}>
      <div style={spinnerStyle}></div>
      <div style={textStyle}><Text tid={"Progressing"}/></div>
      <style>{`
        @keyframes spin {
          0%   { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};


export default LoadingOverlay;
